import React from "react";
import "./App.scss";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import AppRouter from "@configs/router";
import store from "@configs/store";
import './assets/scss/styles.scss'
import { I18nextProvider } from "react-i18next";
import i18n from "./translation/i18n";

function App() {
    return (
        <div className="App">
                <I18nextProvider i18n={i18n}>

            <Provider store={store}>
                <BrowserRouter>
                    <AppRouter />
                </BrowserRouter>
            </Provider>
            </I18nextProvider>
        </div>
    );
}

export default App;
